import { ActivatedRouteSnapshot } from "@angular/router";
import { Helper } from "../helpers/helper.service";

export const backBreadCrumbResolver = (route: ActivatedRouteSnapshot) => {
  if (Helper.isDefined(route.params['id']) &&
    !Helper.isDefined(route.params['modelId']) &&
    !Helper.isDefined(route.params['subjectId']) &&
    !Helper.isDefined(route.params['collectionId'])) {
    return route.data['path'] + route.params['id'] + '/show';
  }
  if (Helper.isDefined(route.params['collectionId']) &&
    !Helper.isDefined(route.params['modelId']) &&
    !Helper.isDefined(route.params['subjectId']) &&
    !Helper.isDefined(route.params['id'])) {
    return route.data['path'] + route.params['collectionId'] + '/show';
  }
  if (Helper.isDefined(route.params['modelId']) &&
    !Helper.isDefined(route.params['collectionId']) &&
    !Helper.isDefined(route.params['subjectId']) &&
    !Helper.isDefined(route.params['id'])) {
    return route.data['path'] + route.params['modelId'] + '/show';
  }
  if (Helper.isDefined(route.params['subjectId']) &&
    !Helper.isDefined(route.params['collectionId']) &&
    !Helper.isDefined(route.params['modelId']) &&
    !Helper.isDefined(route.params['id'])) {
    return route.data['path'] + route.params['subjectId'] + '/show';
  }
  if (Helper.isDefined(route.params['id'] ) && Helper.isDefined(route.params['modelId'])) {
    return route.data['path'] + route.params['modelId'] + '/show';
  }
  if (Helper.isDefined(route.params['id'] ) && Helper.isDefined(route.params['subjectId'])) {
    return route.data['path'] + route.params['subjectId'] + '/show';
  }
  if (Helper.isDefined(route.params['id'] ) && Helper.isDefined( route.params['collectionId'])) {
    return route.data['path'] + route.params['collectionId'] + '/show';
  }
};

